import React from "react";
import { SELFCARE_URL } from "../../../../config/configs";
import {
  Box,
  Container,
  Typography,
  useMediaQuery,
} from "../../../common/MuiImports";

const NetworkAccessDenied: React.FC = () => {
  const isMobile = useMediaQuery("(max-width: 600px)");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
      data-test-id="network-access-denied-container"
    >
      <Container
        component="main"
        maxWidth="lg"
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          paddingTop: "40px",
          paddingLeft: isMobile ? "0px" : "40px",
        }}
        data-test-id="network-access-denied-content"
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            marginLeft: isMobile ? 2 : 6,
            marginRight: "auto",
          }}
        >
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              color: "#4A4A4A",
              fontFamily: "Museo900",
              fontSize: "2.5rem",
              mb: 2,
            }}
          >
            This site’s off-limits on the free plan.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "#4A4A4A",
              fontSize: "1.25rem",
              mb: 1,
            }}
          >
            But don’t worry—you can unlock it and get faster speeds when you
            switch to a monthly Blazing or Extreme account. Bonus: We'll give
            you up to $35 off your first month.{" "}
            <a href={SELFCARE_URL}>My Account</a>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default NetworkAccessDenied;
